export default __webpack_public_path__ + "static/media/mesa_02.62c74628.png";